<template>
  <div v-show="list.length > 0" class="swiper-container product-swiper">
    <div class="productList swiper-wrapper">
      <div v-for="(item, index) in list" :key="index" class="productItem swiper-slide" :class="{ 'length' : list.length == 1 }">
        <div class="img-box">
          <img v-lazy="item.thumb">
        </div>
        <div class="right">
          <div class="product-name two-line-ellipsis">{{ item.title }}</div>
          <div class="shop-info">
            <div v-if="item.price" class="price">参考价:<b class="red">￥</b><span class="red num">{{ item.price }}</span></div>
            <div class="btn" @click="_toItemDetail(index)">立即购买</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Lazyload } from 'vant';
import Swiper from 'swiper';
import Util from '@/lib/util';

Vue.use(Lazyload);

export default {
  name: 'ArticleDetailProduct',
  props: {
    productList: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    productList() {
      this._initData();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this._initData();
    });
  },
  methods: {
    _initData() {
      if (Util.isArray(this.productList) && this.productList.length > 0) this.list.push(...this.productList);
      // eslint-disable-next-line no-unused-vars
      const swiper = new Swiper('.product-swiper', {
        freeMode: true,
        initialSlide: 0,
        observer: true,
        observeParents: true,
        slidesPerView: 1.1,
        spaceBetween: 10,
      });
    },

    _toItemDetail(index) {
      window.location.href = this.list[index].url;
    },
  },
};
</script>

<style scoped lang="less">
.swiper-container {
  margin-top: 40px;
  box-sizing: border-box;
}

.productList {
  .productItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 28px;
    background: #f5f6f9;
    color: #333;
    border-radius: 10px;
    box-sizing: border-box;
    width: 629px !important;

    &.length {
      width: 694px !important;
      margin-bottom: 40px;
    }
  }

  .img-box {
    width: 160px;
    height: 160px;
    margin-right: 20px;

    img {
      width: 160px;
      height: 160px;
      border-radius: 10px;
      object-fit: cover;
    }
  }

  .right {
    // margin-left: auto;
    flex: auto;

    .product-name {
      font-size: 30px;
      font-weight: bold;
      line-height: 42px;
    }

    .shop-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24px;
      margin-top: 30px;

      .price {
        font-size: 22px;
        color: #999;

        .red {
          color: #ee2d1b;
        }

        .num {
          font-size: 28px;
          font-weight: bold;
        }
      }

      .btn {
        color: #fff;
        width: 140px;
        height: 46px;
        line-height: 46px;
        background: linear-gradient(90deg, rgba(255, 102, 51, 1), rgba(238, 45, 27, 1));
        border-radius: 23px;
        text-align: center;
      }
    }
  }
}
</style>
